import { IconTruckDelivery } from '@tabler/icons';

import {
  Button,
  Modal,
  ModalDescription,
  ModalFooter,
  ModalHeader,
  ModalTitle,
} from '#root/components/ui';
import { USER_SHIPMENTS } from '#root/constants/navigation';
import { ShippingStatus } from '#root/models/Shipping';
import type { ShippingStatusType } from '#root/models/Shipping';

interface ShippingOfficeDialogProps {
  open: boolean;
  onClose: () => void;
  // Estado del envío del acuerdo
  shippingStatus?: ShippingStatusType | null;
}

/**
 * Modal de los badges "Enviando a…" y "Recojo en oficina" (§7.5): desde la entrega, el envío se
 * gestiona en Mis Envíos. Un envío en CREADO todavía no aparece ahí, así que solo se avisa.
 */
const ShippingOfficeDialog = (props: ShippingOfficeDialogProps) => {
  const { open, onClose, shippingStatus } = props;
  const isListed = shippingStatus !== ShippingStatus.created;

  return (
    <Modal open={open} onClose={onClose} size="sm">
      {/* Mismo ícono que "Mis Envíos" en el menú lateral */}
      <ModalHeader icon={<IconTruckDelivery />} tone="info">
        <ModalTitle>Tu pedido ya llegó a la oficina de envíos</ModalTitle>
        <ModalDescription>
          Desde ahora, las gestiones de tu envío (dirección, recojo y pago) las haces en Mis
          Envíos.
          {!isListed && ' Lo verás en Mis Envíos apenas lo registremos (te avisaremos).'}
        </ModalDescription>
      </ModalHeader>
      <ModalFooter>
        {isListed && (
          <Button variant="outline" to={USER_SHIPMENTS}>
            Ir a Mis Envíos
          </Button>
        )}
        <Button onClick={onClose}>Entendido</Button>
      </ModalFooter>
    </Modal>
  );
};

export default ShippingOfficeDialog;
